/* eslint-disable react/no-danger */
/* eslint-disable max-len */
import React from 'react';
import {
  Container,
  Divider,
  Grid,
  Typography,
} from '@material-ui/core';

import Layout from '../../components/layout';

const rows = [
  { title: '商号', body: '合同会社ふたさじ (Futasaji LLC)' },
  { title: '設立', body: '2021年4月13日' },
  { title: '資本金', body: '100万円' },
  { title: '本社所在地', body: '〒105-0013<br/>東京都港区浜松町2丁目2番15号 浜松町ダイヤビル2F' },
  { title: '代表者', body: '代表社員 佐藤 弘幸' },
  { title: '従業員数', body: '1名' },
  { title: '事業内容', body: '・スマートフォン用アプリケーションの企画、開発及び運営<br/>・ウェブサイトの企画、制作及び運営<br/>・広告、宣伝及びマーケティングリサーチに関する業務<br/>・各種コンサルティング業務' },
];

const Page = () => (
  <Layout>
    <Container maxWidth="md">
      <Typography align="center" paragraph variant="h5" style={{ marginBottom: 64 }}>会社概要</Typography>
      {rows.map((value) => (
        <div>
          <Grid container style={{ marginTop: 20, marginBottom: 20 }}>
            <Grid item xs={4}><Typography variant="body2">{ value.title }</Typography></Grid>
            <Grid item xs={8}>
              <Typography variant="body2">
                <div dangerouslySetInnerHTML={{ __html: value.body }} />
              </Typography>
            </Grid>
          </Grid>
          <Divider />
        </div>
      ))}

    </Container>
  </Layout>
);

export default Page;
